import { Folder, Identifiable } from "@planzone/dto";

function getSelectedFolderPath(
  selectedFolder: Identifiable<Folder>,
  folder: Identifiable<Folder>,
): {
  path: Identifiable<Folder>[];
  hasMatched: boolean;
} {
  const res: { path: Identifiable<Folder>[]; hasMatched: boolean } =
    folder.children
      .filter(({ type }) => type === "folder")
      .reduce<{
        path: Identifiable<Folder>[];
        hasMatched: boolean;
      }>(
        (p, child) => {
          const c = child as Identifiable<Folder>;
          const { path, hasMatched } = getSelectedFolderPath(selectedFolder, c);

          return hasMatched ? { hasMatched, path } : p;
        },
        { hasMatched: false, path: [] },
      );
  const isMatching = folder.uuid === selectedFolder.uuid;

  return res.hasMatched || isMatching
    ? { hasMatched: res.hasMatched || isMatching, path: [folder, ...res.path] }
    : res;
}

export { getSelectedFolderPath };
